module.exports = __webpack_public_path__ + "static/the-art-of-happiness-11f36f1f4a2a1b298343b0d853e3aff4.jpg";